<template>
  <div class="row">
    <div v-for="(vendor_group, i) in vendorGroups" :key="i" class="col-24">
      <h2 class="mb-2">{{ vendor_group[0].name[0].toUpperCase() }}</h2>
      <div class="row mb-4">
        <VendorTile
          v-for="(vendor, j) in vendor_group"
          :key="j"
          :badges="vendor.badges"
          :categories="vendor.categories"
          :image="vendor.image"
          :name="vendor.name"
          :product_link="vendor.product_link"
          :link="vendor.url"
          :action_button_text="translations['action_button_text']"
        >
        </VendorTile>
      </div>
    </div>
  </div>
</template>

<script>
import VendorTile from "../vendor-tiles/VendorTile.vue";

export default {
  name: "VendorList",
  components: {
    VendorTile,
  },
  props: {
    vendors: {
      type: Array,
      required: true,
    },
    translations: {
      type: Object,
      required: true,
    },
  },
  computed: {
    vendorGroups() {
      const groups = {};

      for (const vendor of this.vendors) {
        const letter = vendor.name[0].toUpperCase();
        const group = groups[letter] || [];
        group.push(vendor);
        groups[letter] = group;
      }

      for (const key in groups) {
        groups[key] = groups[key].sort((a, b) => b.badges.length - a.badges.length);
      }

      return Object.keys(groups)
        .sort()
        .reduce(
          (acc, key) => ({
            ...acc,
            [key]: groups[key],
          }),
          {}
        );
    },
  },
};
</script>
